module.exports = __webpack_public_path__ + "files/2291980bac6d45447c902cfa41da6314.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/open-sans-v13-latin-ext_latin_cyrillic-ext_greek-ext_greek_cyrillic_vietnamese-800.eot
 ** module id = 422
 ** module chunks = 0
 **/